module.exports = __webpack_public_path__ + "img/paint_splatter.c007cb08.png";